<template>
  <div class="calico-history-page">
    <div class="calico-history-container">
      <div class="calico-history-row">
        <CalicoHistory
          type="business"
          name="ABC"
          address="Chicago, IL"
        />
      </div>
      <div class="calico-history-row">
        <CalicoHistory
          type="prompt"
          prompt="This is a prompt"
        />
      </div>
    </div>
  </div>
</template>

<script lang="js">
import CalicoHistory from '@/components/calico/history/index.vue'
export default {
  name: 'CalicoHistoryPage',
  components: {
    CalicoHistory
  },
}
</script>
<style lang="scss">
.calico-history-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-history-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;
    .calico-history-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
      width: 100%;
    }
  }
}
</style>
